import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=43162d64&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=43162d64&prod&lang=scss"
import style1 from "./Order.vue?vue&type=style&index=1&id=43162d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43162d64",
  null
  
)

export default component.exports